////////////////////

const moment = require('moment');

const config = require('@/config.js')[ process.env.NODE_ENV || 'local' ];
import base_module from '@/vue-model-mirror/stores/base_v2.module';
import { authHeader } from '@/helpers';
const axios = require('axios');

var options = {
    model_name    : 'item',
    send_alert    : false,
    default_order : 'created DESC',
    page          : 1,
};

var base = new base_module( options );

const state = {
    ...base.state,
};

const actions = {
    ...base.actions,
};

const mutations = {
    ...base.mutations,
};

export default {
    namespaced : true,
    ...base,
    state,
    actions,
    mutations,
};


